"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Reader = exports.TypeEnum = void 0;
var DataStream_1 = __importDefault(require("./DataStream"));
var utils_1 = require("./utils");
var const_1 = __importDefault(require("./const"));
/**
 * `Object Type` in `2.6.1 Compound File Directory Entry`
 *
 * See also: [[MS-CFB]: Compound File Directory Entry | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/60fe8611-66c3-496b-b70d-a504c94c9ace)
 */
var TypeEnum;
(function (TypeEnum) {
  /**
   * `Storage Object`
   *
   * storage object: An object in a compound file that is analogous to a file system directory. The parent object of a storage object must be another storage object or the root storage object.
   *
   * See also:
   *
   * - [[MS-CFB]: Other Directory Entries | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/b37413bb-f3ef-4adc-b18e-29bddd62c26e)
   * - [[MS-CFB]: Glossary | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/59ccb2ef-1ce5-41e3-bc30-075dea759d0a#gt_c3ddf892-3f55-4561-8804-20325dbc8fba)
   */
  TypeEnum[TypeEnum["DIRECTORY"] = 1] = "DIRECTORY";
  /**
   * `Stream Object`
   *
   * - stream object: An object in a compound file that is analogous to a file system file. The parent object of a stream object must be a storage object or the root storage object.
   *
   * See also:
   * - [[MS-CFB]: Compound File User-Defined Data Sectors | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/b089deda-be20-4b4a-aad5-fbe68bb19672)
   * - [[MS-CFB]: Glossary | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/59ccb2ef-1ce5-41e3-bc30-075dea759d0a#gt_9f598e1c-0d65-4845-8f06-8d50f7a32fd5)
   */
  TypeEnum[TypeEnum["DOCUMENT"] = 2] = "DOCUMENT";
  /**
   * `Root Storage Object`
   *
   * - root storage object: A storage object in a compound file that must be accessed before any other storage objects and stream objects are referenced. It is the uppermost parent object in the storage object and stream object hierarchy.
   *
   * See also:
   * - [[MS-CFB]: Root Directory Entry | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/026fde6e-143d-41bf-a7da-c08b2130d50e)
   * - [[MS-CFB]: Glossary | Microsoft Docs](https://docs.microsoft.com/en-us/openspecs/windows_protocols/ms-cfb/59ccb2ef-1ce5-41e3-bc30-075dea759d0a#gt_d49237e3-04dd-4823-a0a5-5e23f750a5f4)
   */
  TypeEnum[TypeEnum["ROOT"] = 5] = "ROOT";
})(TypeEnum = exports.TypeEnum || (exports.TypeEnum = {}));
/**
 * Original msg file (CFBF) reader which was implemented in MsgReader.
 */
var Reader = /** @class */ (function () {
  function Reader(arrayBuffer) {
    this.ds = new DataStream_1.default(arrayBuffer, 0, DataStream_1.default.LITTLE_ENDIAN);
  }
  Reader.prototype.isMSGFile = function () {
    this.ds.seek(0);
    return (0, utils_1.arraysEqual)(const_1.default.FILE_HEADER, this.ds.readInt8Array(const_1.default.FILE_HEADER.length));
  };
  Reader.prototype.headerData = function () {
    this.bigBlockSize = this.ds.readByte(30) == const_1.default.MSG.L_BIG_BLOCK_MARK ? const_1.default.MSG.L_BIG_BLOCK_SIZE : const_1.default.MSG.S_BIG_BLOCK_SIZE;
    this.bigBlockLength = this.bigBlockSize / 4;
    // system data
    this.xBlockLength = this.bigBlockLength - 1;
    // header data
    this.batCount = this.ds.readInt(const_1.default.MSG.HEADER.BAT_COUNT_OFFSET);
    this.propertyStart = this.ds.readInt(const_1.default.MSG.HEADER.PROPERTY_START_OFFSET);
    this.sbatStart = this.ds.readInt(const_1.default.MSG.HEADER.SBAT_START_OFFSET);
    this.sbatCount = this.ds.readInt(const_1.default.MSG.HEADER.SBAT_COUNT_OFFSET);
    this.xbatStart = this.ds.readInt(const_1.default.MSG.HEADER.XBAT_START_OFFSET);
    this.xbatCount = this.ds.readInt(const_1.default.MSG.HEADER.XBAT_COUNT_OFFSET);
  };
  Reader.prototype.convertName = function (offset) {
    var nameLength = this.ds.readShort(offset + const_1.default.MSG.PROP.NAME_SIZE_OFFSET);
    if (nameLength < 1) {
      return '';
    }
    else {
      return this.ds.readStringAt(offset, nameLength / 2).split('\0')[0];
    }
  };
  Reader.prototype.convertProperty = function (offset) {
    return {
      type: this.ds.readByte(offset + const_1.default.MSG.PROP.TYPE_OFFSET),
      name: this.convertName(offset),
      // hierarchy
      previousProperty: this.ds.readInt(offset + const_1.default.MSG.PROP.PREVIOUS_PROPERTY_OFFSET),
      nextProperty: this.ds.readInt(offset + const_1.default.MSG.PROP.NEXT_PROPERTY_OFFSET),
      childProperty: this.ds.readInt(offset + const_1.default.MSG.PROP.CHILD_PROPERTY_OFFSET),
      // data offset
      startBlock: this.ds.readInt(offset + const_1.default.MSG.PROP.START_BLOCK_OFFSET),
      sizeBlock: this.ds.readInt(offset + const_1.default.MSG.PROP.SIZE_OFFSET),
    };
  };
  Reader.prototype.convertBlockToProperties = function (propertyBlockOffset, props) {
    var propertyCount = this.bigBlockSize / const_1.default.MSG.PROP.PROPERTY_SIZE;
    var propertyOffset = this.getBlockOffsetAt(propertyBlockOffset);
    for (var i = 0; i < propertyCount; i++) {
      if (this.ds.byteLength < propertyOffset + const_1.default.MSG.PROP.TYPE_OFFSET) {
        break;
      }
      var propertyType = this.ds.readByte(propertyOffset + const_1.default.MSG.PROP.TYPE_OFFSET);
      switch (propertyType) {
        case const_1.default.MSG.PROP.TYPE_ENUM.ROOT:
        case const_1.default.MSG.PROP.TYPE_ENUM.DIRECTORY:
        case const_1.default.MSG.PROP.TYPE_ENUM.DOCUMENT:
          props.push(this.convertProperty(propertyOffset));
          break;
      }
      propertyOffset += const_1.default.MSG.PROP.PROPERTY_SIZE;
    }
  };
  Reader.prototype.createPropertyHierarchy = function (props, nodeProperty) {
    if (!nodeProperty || nodeProperty.childProperty == const_1.default.MSG.PROP.NO_INDEX) {
      return;
    }
    nodeProperty.children = [];
    var children = [nodeProperty.childProperty];
    while (children.length != 0) {
      var currentIndex = children.shift();
      var current = props[currentIndex];
      if (current == null) {
        continue;
      }
      nodeProperty.children.push(currentIndex);
      if (current.type == const_1.default.MSG.PROP.TYPE_ENUM.DIRECTORY) {
        this.createPropertyHierarchy(props, current);
      }
      if (current.previousProperty != const_1.default.MSG.PROP.NO_INDEX) {
        children.push(current.previousProperty);
      }
      if (current.nextProperty != const_1.default.MSG.PROP.NO_INDEX) {
        children.push(current.nextProperty);
      }
    }
  };
  Reader.prototype.propertyDataReader = function (propertyStart) {
    var props = [];
    var currentOffset = propertyStart;
    while (currentOffset != const_1.default.MSG.END_OF_CHAIN) {
      this.convertBlockToProperties(currentOffset, props);
      currentOffset = this.getNextBlock(currentOffset);
    }
    this.createPropertyHierarchy(props, props[0]);
    return props;
  };
  /**
   * Parse msg file.
   */
  Reader.prototype.parse = function () {
    this.headerData();
    this.batData = this.batDataReader();
    if (this.xbatCount > 0) {
      this.xbatDataReader();
    }
    this.sbatData = this.sbatDataReader();
    this.propertyData = this.propertyDataReader(this.propertyStart);
  };
  Reader.prototype.batCountInHeader = function () {
    var maxBatsInHeader = (const_1.default.MSG.S_BIG_BLOCK_SIZE - const_1.default.MSG.HEADER.BAT_START_OFFSET) / 4;
    return Math.min(this.batCount, maxBatsInHeader);
  };
  Reader.prototype.batDataReader = function () {
    var result = new Array(this.batCountInHeader());
    this.ds.seek(const_1.default.MSG.HEADER.BAT_START_OFFSET);
    for (var i = 0; i < result.length; i++) {
      result[i] = this.ds.readInt32();
    }
    return result;
  };
  Reader.prototype.getBlockOffsetAt = function (offset) {
    return (offset + 1) * this.bigBlockSize;
  };
  Reader.prototype.getBlockAt = function (offset) {
    var startOffset = this.getBlockOffsetAt(offset);
    this.ds.seek(startOffset);
    return this.ds.readInt32Array(this.bigBlockLength);
  };
  Reader.prototype.getBlockValueAt = function (offset, index) {
    var startOffset = this.getBlockOffsetAt(offset);
    this.ds.seek(startOffset + 4 * index);
    return this.ds.readInt32();
  };
  Reader.prototype.getNextBlockInner = function (offset, blockOffsetData) {
    var currentBlock = Math.floor(offset / this.bigBlockLength);
    var currentBlockIndex = offset % this.bigBlockLength;
    var startBlockOffset = blockOffsetData[currentBlock];
    if (typeof startBlockOffset === "undefined") {
      return const_1.default.MSG.END_OF_CHAIN;
    }
    return this.getBlockValueAt(startBlockOffset, currentBlockIndex);
  };
  Reader.prototype.getNextBlock = function (offset) {
    return this.getNextBlockInner(offset, this.batData);
  };
  Reader.prototype.sbatDataReader = function () {
    var result = [];
    var startIndex = this.sbatStart;
    for (var i = 0; i < this.sbatCount && startIndex && startIndex != const_1.default.MSG.END_OF_CHAIN; i++) {
      result.push(startIndex);
      startIndex = this.getNextBlock(startIndex);
    }
    return result;
  };
  Reader.prototype.xbatDataReader = function () {
    var batCount = this.batCountInHeader();
    var batCountTotal = this.batCount;
    var remainingBlocks = batCountTotal - batCount;
    var nextBlockAt = this.xbatStart;
    for (var i = 0; i < this.xbatCount; i++) {
      var xBatBlock = this.getBlockAt(nextBlockAt);
      var blocksToProcess = Math.min(remainingBlocks, this.xBlockLength);
      for (var j = 0; j < blocksToProcess; j++) {
        var blockStartAt = xBatBlock[j];
        if (blockStartAt == const_1.default.MSG.UNUSED_BLOCK || blockStartAt == const_1.default.MSG.END_OF_CHAIN) {
          break;
        }
        this.batData.push(blockStartAt);
      }
      remainingBlocks -= blocksToProcess;
      nextBlockAt = xBatBlock[this.xBlockLength];
      if (nextBlockAt == const_1.default.MSG.UNUSED_BLOCK || nextBlockAt == const_1.default.MSG.END_OF_CHAIN) {
        break;
      }
    }
  };
  Reader.prototype.getNextBlockSmall = function (offset) {
    return this.getNextBlockInner(offset, this.sbatData);
  };
  Reader.prototype.getChainByBlockSmall = function (fieldProperty) {
    var blockChain = [];
    var nextBlockSmall = fieldProperty.startBlock;
    while (nextBlockSmall != const_1.default.MSG.END_OF_CHAIN) {
      blockChain.push(nextBlockSmall);
      nextBlockSmall = this.getNextBlockSmall(nextBlockSmall);
    }
    return blockChain;
  };
  Reader.prototype.readDataByBlockSmall = function (startBlock, blockSize) {
    var byteOffset = startBlock * const_1.default.MSG.SMALL_BLOCK_SIZE;
    var bigBlockNumber = Math.floor(byteOffset / this.bigBlockSize);
    var bigBlockOffset = byteOffset % this.bigBlockSize;
    var rootProp = this.propertyData[0];
    var nextBlock = rootProp.startBlock;
    for (var i = 0; i < bigBlockNumber; i++) {
      nextBlock = this.getNextBlock(nextBlock);
    }
    var blockStartOffset = this.getBlockOffsetAt(nextBlock);
    this.ds.seek(blockStartOffset + bigBlockOffset);
    return this.ds.readUint8Array(blockSize);
  };
  Reader.prototype.readChainDataByBlockSmall = function (fieldProperty, chain) {
    var resultData = new Uint8Array(fieldProperty.sizeBlock);
    for (var i = 0, idx = 0; i < chain.length; i++) {
      var data = this.readDataByBlockSmall(chain[i], const_1.default.MSG.SMALL_BLOCK_SIZE);
      if (resultData.length < idx + data.length) {
        resultData.set(data.subarray(0, resultData.length - idx), idx);
      }
      else {
        resultData.set(data, idx);
      }
      idx += data.length;
    }
    return resultData;
  };
  Reader.prototype.readProperty = function (fieldProperty) {
    if (!fieldProperty.sizeBlock) {
      return new Uint8Array(0);
    }
    else if (fieldProperty.sizeBlock < const_1.default.MSG.BIG_BLOCK_MIN_DOC_SIZE) {
      var chain = this.getChainByBlockSmall(fieldProperty);
      if (chain.length == 1) {
        return this.readDataByBlockSmall(fieldProperty.startBlock, fieldProperty.sizeBlock);
      }
      else if (chain.length > 1) {
        return this.readChainDataByBlockSmall(fieldProperty, chain);
      }
      return new Uint8Array(0);
    }
    else {
      var nextBlock = fieldProperty.startBlock;
      var remaining = fieldProperty.sizeBlock;
      var position = 0;
      var resultData = new Uint8Array(fieldProperty.sizeBlock);
      while (1 <= remaining) {
        var blockStartOffset = this.getBlockOffsetAt(nextBlock);
        this.ds.seek(blockStartOffset);
        var partSize = Math.min(remaining, this.bigBlockSize);
        var part = this.ds.readUint8Array(partSize);
        resultData.set(part, position);
        position += partSize;
        remaining -= partSize;
        nextBlock = this.getNextBlock(nextBlock);
      }
      return resultData;
    }
  };
  /**
   * Get binary from document in CFBF.
   *
   * @param index entry index
   * @returns binary
   * @internal
   */
  Reader.prototype.readFileOf = function (index) {
    return this.readProperty(this.propertyData[index]);
  };
  Reader.prototype.folderOf = function (index) {
    var _this = this;
    var propertyData = this.propertyData;
    if (!propertyData) {
      return null;
    }
    var folder = propertyData[index];
    return {
      dataId: index,
      name: folder.name,
      fileNames: function () {
        var children = folder.children;
        if (children) {
          return children
            .map(function (subIndex) { return propertyData[subIndex]; })
            .filter(function (it) { return it.type === TypeEnum.DOCUMENT; })
            .map(function (it) { return it.name; });
        }
        return [];
      },
      fileNameSets: function () {
        var children = folder.children;
        if (children) {
          return children
            .map(function (subIndex) {
              return ({
                subIndex: subIndex,
                entry: propertyData[subIndex]
              });
            })
            .filter(function (it) { return it.entry.type === TypeEnum.DOCUMENT; })
            .map(function (it) {
              return ({
                name: it.entry.name,
                length: it.entry.sizeBlock,
                dataId: it.subIndex,
                provider: function () { return _this.readProperty(it.entry); },
              });
            });
        }
        return [];
      },
      subFolders: function () {
        var children = folder.children;
        if (children) {
          return children
            .filter(function (subIndex) { return propertyData[subIndex].type == TypeEnum.DIRECTORY; })
            .map(function (subIndex) { return _this.folderOf(subIndex); });
        }
        return [];
      },
      readFile: function (fileName) {
        var children = folder.children;
        if (children) {
          for (var _i = 0, children_1 = children; _i < children_1.length; _i++) {
            var subIndex = children_1[_i];
            var file = propertyData[subIndex];
            if (file && file.type === TypeEnum.DOCUMENT && file.name === fileName) {
              return _this.readProperty(file);
            }
          }
        }
        return null;
      },
    };
  };
  /**
   * Get reader access to CFBF (valid after successful call of {@link parse}).
   *
   * @returns root folder
   */
  Reader.prototype.rootFolder = function () {
    return this.folderOf(0);
  };
  return Reader;
}());
exports.Reader = Reader;